import { render, staticRenderFns } from "./ServiceProfitStatistics.vue?vue&type=template&id=82d15ab6"
import script from "./ServiceProfitStatistics.vue?vue&type=script&lang=ts"
export * from "./ServiceProfitStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports